
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import UserDataOther from "@/components/UserDataOther.vue"
    import {dictApi, deptApi, userApi, teacherApi, roleApi, mechanismApi} from "@/api/organization";
    import axios from "axios";
    import baseUrl, {imageUrl} from "../../constants";
    import ProcessSignImg from "@/components/ProcessSignImg.vue";
    const {regionData} =require("@/js/region/region");

    @Component({
        name: "userData",
        components: {ProcessSignImg, SetTableColumns,UserDataOther}
    })
    export default class Home extends Vue {
        title = "";
        pageType = "0";  //0添加  1编辑  2查看 3个人
        id = "0";   //用户id
        deptId = "";  //选中的部门id
        private closePage: any;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        addform = {
            idCard: "",  //身份证号
            name: "",  //姓名
            formerName: "",    //曾用名
            gender: "",    //性别
            birthday: "",    //出生日期
            ethnicity: "",    //民族
            phone: "",    //手机号码
            nativePlace: "",    //籍贯
            nativePlaceArr: "",    //籍贯
            birthPlace: "",    //出生地
            birthPlaceArr: "",    //出生地
            education: "",    //最高学历
            degree: "",    //最高学位
            politicalStatus: "",    //政治面貌
            admissionTime: "",    //入党（团、派别）日期
            workStartTime: "",    //参加工作日期
            engagedStartTime: "",    //从事计量工作开始日期
            avatar: "",  //头像
            signImage: "", // 签名图
        } as any
        addform2 = {
            category: "",  //人员类别
            enterDate: "",  //进入单位年月
            enterForm: "",  //进入单位形式
            status: "",  //人员身份
            workType: "",  //现在从事工作
            post: "",  //现任行政职务
            postTime: "",  //任现职务日期
            level: "",  //现行政职级
            levelTime: "",  //取得现行政职级日期
            title: "",  //现技术职称资格
            titleTime: "",  //取得现技术职称资格日期
            currentPosition: "",  //现聘职级
            currentPositionTime: "",  //聘现职级日期
        } as any
        addform3 = {
            name: "",  //用户名
            pwdOriginal: "",  //密码
        } as any
        roleArr = [];  //角色备选列表
        roleIds = [];  //选中的角色
        rules = {
            idCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
            name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
            phone: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
        }
        rules2 = {
            organizationName: [{ required: true, message: '请选择单位', trigger: 'change' }],
        }
        useUser = false;
        organizationName = "";
        organizationId = "";
        dictTitle = {
            "C031": "ethnicity",  //民族
            "xl": "education",  //学历
            "xw": "degree",  //学位
            "C029": "politicalStatus",  //政治面貌
            "employee_category": "category",  //人员类别
            "jrbdwxs1": "enterForm",  //进入单位形式
            "rysf": "status",  //人员身份
            "xcsgz1": "workType",  //现在从事工作
            "xrzw": "post",  //现任行政职务
            "xrzj": "level",  //现行政职级
            "xrzg": "title",  //现技术职称资格
            "xpgw": "currentPosition",  //现聘职级
        } as any;
        dictList = {
            ethnicity: [],  //民族
            education: [],  //学历
            degree: [],  //学位
            politicalStatus: [],  //政治面貌
            category: [],  //人员类别
            enterForm: [],  //进入单位形式
            status: [],  //人员身份
            workType: [],  //现在从事工作
            post: [],  //现任行政职务
            level: [],  //现行政职级
            title: [],  //现技术职称资格
            currentPosition: [],  //现聘职级
        } as any
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization:""}
        regionData = regionData

        depart = {
            saving: false,
            departs:[],
            form: {} as any,
            rules: {
                name: [
                    { required: true, message: "请输入部门名称", trigger: "blur" }
                ]
            },
            selected:null,
            editing:false,
        }
        moving = false;
        mechanismTypeData = {};
        flatMenus = [];
        userData = null as any;
        showCardId = "0";
        fullScreen = false;

        mounted() {
            if(this.$route.path.indexOf('external') != -1){
                this.fullScreen = true;
            }
            this.init();
        }

        //region 部门管理
        listDept(){
            //如果没有单位，无法加载部门
            if(!this.userData.organizationId) return;
            deptApi.tree({orgId:this.userData.organizationId}).then((r:any)=>{
                if(r.data.result === 0){
                    const rData = r.data.data
                    this.depart.departs = rData;

                    const flatMenus = [] as any;
                    flatMenus.push(rData[0])
                    flat(rData);
                    // eslint-disable-next-line no-inner-declarations
                    function flat(arr: any){
                        for(const d of arr){
                            if(d.children.length > 0){
                                flat(d.children)
                            }else{
                                flatMenus.push(d);
                            }
                        }
                    }
                    this.flatMenus = flatMenus;
                }
            })
        }
        gitDeptName(){
            let text = "部门";
            const obj = this.flatMenus.find((e:any) => e.id == this.addform.departmentId) as any;
            if(obj){
                text = obj.name
            }
            return text;
        }
        moveTeacher(){
            this.moving = true;
        }
        moveToHere(dept: any){
            this.$confirm("确实要将用户" + this.addform.name + "移动到部门" + dept.name + "吗？","确认操作",{type:"info"}).then(r=>{
                userApi.moveToDept({
                    ids: this.addform.id,
                    deptId: dept.id
                }).then((r: any)=>{
                    if(r.data.result === 0){
                        this.moving = false;
                        this.$message.success("移动用户成功");
                        this.addform.departmentId = dept.id;
                        this.addform.departmentName = dept.name;
                    }
                })
            });
        }

        init(){
            this.pageType = this.$route.params.type;
            this.id = this.$route.params.id;
            this.showCardId = this.$route.params.show;
            this.deptId = this.$route.query.deptId?this.$route.query.deptId as string:"";
            this.userData = this.$store.state.AuthedUser;
            console.log(this.userData)
            axios.all([
                    this.getDict("C031"),
                    this.getDict("xl"),
                    this.getDict("xw"),
                    this.getDict("C029"),
                    this.getDict("employee_category"),
                    this.getDict("jrbdwxs1"),
                    this.getDict("rysf"),
                    this.getDict("xcsgz1"),
                    this.getDict("xrzw"),
                    this.getDict("xrzj"),
                    this.getDict("xrzg"),
                    this.getDict("xpgw"),
                    this.listRole(),
                    this.listDept()
                ],
            ).then(axios.spread((acct,perms)=>{
                if(this.id != "0"){
                    this.loadDetail();
                }else if(this.pageType == "3"){
                    this.id = this.userData.id;
                    this.loadDetail();
                }
            }))
        }
        loadDetail(){
            let api;
            if(this.pageType == "3"){
                api = userApi.getOne({id: this.id});
            }else{
                api = userApi.getOne({id: this.id});
            }
            api.then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data as any;
                    if(rData.userBaseInfo){
                        if(rData.userBaseInfo.nativePlace){
                            rData.userBaseInfo.nativePlaceArr = rData.userBaseInfo.nativePlace.split(",");
                        }
                        if(rData.userBaseInfo.birthPlace){
                            rData.userBaseInfo.birthPlaceArr = rData.userBaseInfo.birthPlace.split(",");
                        }
                        this.addform = rData.userBaseInfo;
                    }
                    if(rData.userEmployeeInfo){
                        this.addform2 = JSON.parse(JSON.stringify(rData.userEmployeeInfo));
                    }
                    if(rData.userBaseInfo){
                        this.organizationName = rData.userBaseInfo.organizationName;
                        this.organizationId = rData.userBaseInfo.organizationId;
                    }
                    if(rData.userLoginInfo){
                        if(rData.userLoginInfo.name){
                            this.addform3.name = rData.userLoginInfo.name;
                        }
                        this.addform3.pwdOriginal = rData.userLoginInfo.pwdOriginal
                        this.useUser = true;
                    }else{
                        this.useUser = false;
                    }
                    if(rData.roleIds){
                        this.roleIds = rData.roleIds;
                    }else{
                        this.roleIds = [];
                    }
                }
            })
        }
        getDict(typeCode: string) {
            return dictApi.listDictItem({
                typeCode: typeCode
            }).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    if(this.dictTitle[typeCode]){
                        const b = this.dictTitle[typeCode] as string;
                        this.dictList[b] = rData;
                        // if(rData.length>0){
                        //     if(this.addform[b] !== undefined){
                        //         this.addform[b] = rData[0].dictValue
                        //     }else if(this.addform2[b] !== undefined){
                        //         this.addform2[b] = rData[0].dictValue
                        //     }
                        // }
                    }
                }
            })
        }
        //获取角色
        listRole(){
            roleApi.list(0,undefined).then((r:any)=>{
                if(r.data.result === 0){
                    this.roleArr = r.data.data;
                }
            })
        }
        saveBtn() {
            let form = this.$refs.form as HTMLFormElement;
            let form2 = this.$refs.form2 as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    form2.validate((valid2:any) => {
                        if (valid2) {
                            let params = {
                                userBaseInfo: this.addform,
                                userEmployeeInfo: this.addform2
                            } as any
                            if(this.useUser){
                                if(!this.addform3.name){
                                    this.addform3.name = this.addform.idCard;
                                }
                                params.userLoginInfo = this.addform3
                            }
                            if(params.userBaseInfo.nativePlaceArr){
                                params.userBaseInfo.nativePlace = params.userBaseInfo.nativePlaceArr.join(",");
                            }
                            if(params.userBaseInfo.birthPlaceArr){
                                params.userBaseInfo.birthPlace = params.userBaseInfo.birthPlaceArr.join(",");
                            }
                            if(this.pageType == "0"){
                                //添加默认登录人的单位id
                                params.userBaseInfo.organizationId = this.userData.organizationId;
                            }else{
                                params.userBaseInfo.organizationId = this.organizationId;
                            }
                            if(this.deptId){
                                params.userBaseInfo.departmentId = this.deptId;
                            }
                            params.roleIds = this.roleIds;
                            if(this.id == "0"){
                                //添加人员
                                params.userBaseInfo.type = "1";
                            }
                            userApi.addOrUpdateUser(params).then(r => {
                                if (r.data.result === 0) {
                                    this.$message.success("保存成功");
                                    if(this.pageType != "3"){
                                        this.closePage();
                                    }else{
                                        this.userData.avatar = r.data.data.userBaseInfo.avatar;
                                        //更新缓存的头像
                                        sessionStorage.setItem('AuthedUser', JSON.stringify(this.userData));
                                    }
                                }
                            })
                        }
                    })
                }
            })
        }
        //上传监控
        handleAvatarSuccess(res: any, file: any) {
          if(res.result === 0){
                const rData = res.data;
                userApi.updateSignImage({signImage: rData}).then((r: any) => {
                    if (r.data.result === 0) {
                        this.$message.success("上传成功");
                        this.addform.signImage = rData;
                    }
                })
            }
        }
        //上传头像监控
        beforeAvatarUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';

            if (!isJPG && !isPNG) {
                this.$message.error('上传头像图片只能是 JPG 或 PNG格式!');
            }
            return (isJPG||isPNG);
        }
        unbind(){
            this.$confirm('确定要解绑单位吗？解绑后需要重新登录。', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                userApi.unBind({}).then((r: any) => {
                    if (r.data.result === 0) {
                        this.$message.success("解绑成功");
                        this.$router.push("/login");
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        handleChooseTool(e:any) {
            this.$forceUpdate();
        }
    }
